import { makeStyles } from "tss-react/mui";
import {
  resMedRed,
  resMedLight,
  resMedLightText,
  resMedLightBlue,
} from "../../components/patientTheme";

import * as dTokens from "ui-common/components/design-tokens";
import * as providerDTokens from "ui-common/components/provider-design-tokens";


const headerHeight = "53px";
const contentHeight = `calc(100svh - ${headerHeight})`;

const MaskSelectorToolStyles = makeStyles()((theme) => ({
  appRoot: {
    "@media only screen and (max-width: 639px)": {
      minWidth: "100%",
      maxWidth: "100%",
    },
    "@media only screen and (min-width: 640px)": {
      width: "600px"
    }
  },

  appRootPadding: {
    "@media only screen and (max-width: 639px)": {
      padding: "0 20px",
    },
    "@media only screen and (min-width: 640px)": { }
  },

  mainBox: {
    marginLeft: "auto",
    marginRight: "auto",
  },

  tipsContentBox: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "600px",
  },

  wideLayoutPage: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "794px",
  },

  centeredBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  centeredBoxIfPhone: {
    "@media only screen and (max-width: 639px)": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }
  },

  rightAligned: {
    display: "flex",
    alignItems: "center",
    justifyContent: "right",
  },

  instructionBox: {
    height: "269px",
    width: "100%"
  },

  instructionMainBox: {
    paddingTop: 0,
  },

  instruction: {
    fontSize: 17,
    fontWeight: 400
  },

  centeredText: { textAlign: "center" },

  paddingBox: { padding: "12px" },

  doublePaddingBox: { padding: "24px" },

  verticalPaddingBox: { padding: "12px 0" },

  tipBox: {
    color: resMedLightText,
    backgroundColor: resMedLight,
    width: "100%",
    paddingTop: "12px",
    marginTop: "12px",
  },

  progressBar: {
    height: "7px",
    borderRadius: "4px",
  },

  topTextBox: {
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    paddingTop: 12,
    marginBottom: 12,
    marginLeft: 22,
    marginRight: 22,
  },

  chooseTopTextBox: {
    marginBottom: 0,
    "@media only screen and (max-width: 639px)": {
      marginTop: 24
    },
    "@media only screen and (min-width: 640px)": {
      marginTop: "40px",
    }

  },

  retryHR: {
    height: "1px",
    border: "1px solid #e6e6e7",
    backgroundColor: "rgba(255, 255, 255, 0)",
    boxSizing: "border-box",
    marginBottom: 20,
  },

  buttonBox: {
    marginBottom: "24px"
  },

  faceMeshBox: { marginTop: "32px" },

  link: { color: resMedRed, textDecorationLine: "underline" },

  video: {
    display: "block",
    minHeight: "300px",
    padding: "1px",
  },

  containerBox: { position: "relative" },

  subHeadingTyp: {
    fontSize: "16px",
  },

  boldText: {
    color: dTokens.res_grey_800,
    fontWeight: 700,
  },

  iconContainerBox: {
    marginTop: "12px",
    display: "flex",
  },

  iconColumnBox: {
    width: "33%",
    textAlign: "center",
  },

  iconDescTyp: { fontSize: "14px", marginTop: "8px" },

  topIconDescTyp: { marginTop: "0px", marginBottom: "8px", height: "32px" },

  centerDescTyp: { marginTop: "0px" },

  textButton: { textTransform: "none" },

  zeroBottomMargin: {
    marginBottom: 0,
  },

  iconBox: { marginBottom: "26px" },

  preferNotToLinkBox: {
    paddingBottom: 30,
  },

  verticalChoiceMainBox: {
    paddingTop: 16,
    paddingBottom: 18,
    paddingLeft: 14,
    paddingRight: 12,
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },

  verticalChoiceBorder: {
    borderStyle: "solid",
    borderWidth: "1px",
    borderRadius: "12px",
    borderColor: "#B7B7B8",
    backgroundColor: '#FFFFFF'
  },

  verticalQuestionChoiceBorderSelected: {
    borderStyle: "solid",
    borderWidth: "2px",
    borderRadius: "12px",
    borderColor: dTokens.res_brand_color_005,
    color: dTokens.res_brand_color_005,
    backgroundColor: dTokens.res_001_palette_50
  },

  verticalQuestionChoiceTableRow: {
    display: "flex",
    width: "100%",
    minHeight: "54px",
    alignItems: "center"
  },

  verticalChoiceIconBox: {
    width: 70,
    height: "100%",
    display: "flex",
    alignItems: "center"
  },

  verticalChoiceArrowBox: {
    paddingRight: 60,
    marginTop: "auto",
    marginBottom: "auto",
    height: "100%",
    width: 10,
    position: "relative",

    display: "table-cell",

    "@media only screen and (max-width: 639px)": {
      paddingRight: 10,
    },

  },

  verticalChoiceChoiceArrow: {
    transform: "rotate(270deg)",
    position: "absolute",
    margin: "auto",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
  },

  optionCardPopupLink: {
    color: dTokens.res_brand_color_005,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
    },
    fontSize: "12px",
    fontWeight: "600",
  },

  optionCardPopupBox: {
    background: "white",
    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.35)",
  },

  optionCardPopupText: {
    fontSize: "14px",
    textAlign: "center",
  },

  optionCardOuterBox: {
    display: "flex",
    marginBottom: 10,

    "@media only screen and (max-width: 1199px)": {
      flexWrap: "wrap",
    },
    justifyContent: "center",
  },

  header_back_link: {
    color: "#FFFFFF",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
    },
    fontSize: "16px",
    fontWeight: "700",
  },

  header_back_arrowBox: {
    marginRight: 4,
  },

  header_top_box: {
    backgroundImage:
      "linear-gradient(-269.2374851122082deg, #3362aa 1.448423946615695%, #3d74cb 98.75146501480134%)",
    height: 53,
    textAlign: "center",
  },

  startPageButton: {
    background: theme.palette.common.white,
    borderColor: theme.palette.common.white,
    "&:hover": {
      background: theme.palette.background.default,
    },
  },

  blue_gradient_box: {
    backgroundImage:
      "linear-gradient(-269.2374851122082deg, #3362aa 1.448423946615695%, #3d74cb 98.75146501480134%)",
    height: "100%",
  },

  auto_scan_resp_icon: {
    "@media only screen and (max-width: 600px)": {
      height: "40vh"
    }
  },

  man_measure_resp_icon: {
    "@media only screen and (max-width: 600px)": {
      height: "30vh"
    }
  },

  responsive_image_40_percent_height: {
    "@media only screen and (max-height: 599px)": {
        height: "40svh",
        aspectRatio: "auto"
    },
    "@media only screen and (min-height: 600px)": {
        height: "250px",
        aspectRatio: "auto"
    }
  },

  responsive_image_50_percent_height: {
    "@media only screen and (max-height: 599px)": {
        height: "50svh",
        aspectRatio: "auto"
    },
    "@media only screen and (min-height: 600px)": {
        height: "300px",
        aspectRatio: "auto"
    }
  },

  preamble_get_started_button: {
    height: "40px",
    marginBottom: "24px",
    marginTop: "24px",

    "@media only screen and (max-width: 639px)": {
      minWidth: "100%",
      width: "100%"
    }
  },

  preamble_get_started_box: {
    "@media only screen and (max-width: 639px)": {
      width: "100%",
    },
    "@media only screen and (min-width: 640px)": {
      marginTop: "62px",
      marginBottom: "24px"
    }
  },

  preambleSubtitle: {
    "@media only screen and (max-width: 639px)": {
      marginTop: "12px"
    },
    "@media only screen and (min-width: 640px)": {
      marginTop: "27px",
    }
  },

  choice_continue_button: {
    height: "40px",

    "@media only screen and (max-width: 639px)": {
      minWidth: "100%",
      marginBottom: "16px",
    },
    "@media only screen and (min-width: 640px)": {
      marginBottom: "24px"
    }
  },

  choice_continue_box: {
    marginBottom: "24px",

    "@media only screen and (max-width: 639px)": {
      minWidth: "calc(100% - 40px)",
      position: "absolute",
      bottom: "0px"
    },
    "@media only screen and (min-width: 640px)": {
      marginTop: "62px"
    }
  },

  // Single and dual buttons as described in MASKSEL-2952
  single_button: {
    height: "40px",
    marginBottom: "24px",

    "@media only screen and (max-width: 639px)": {
      minWidth: "calc(100% - 40px)",
      position: "absolute",
      bottom: "0px"
    },
    "@media only screen and (min-width: 640px)": {
      marginTop: "40px"
    }
  },

  dual_button_group: {
    "@media only screen and (max-width: 639px)": {
      display: "none"
    },
    "@media only screen and (min-width: 640px)": {
      marginTop: "40px",
      marginBottom: "24px"
    }
  },

  dual_button_group_mobile: {
    "@media only screen and (max-width: 639px)": {
      backgroundColor: "rgba(255,255,255,0.7)",
      backdropFilter: "blur(64px)",
      boxShadow:"0px -2px 4px 0px rgba(0,0,0,0.1)",
      minWidth: "calc(100% - 40px)",
      position: "absolute",
      right: '0%',
      width: '100vw',
      bottom: "0px"
    },
    "@media only screen and (min-width: 640px)": {
      display: "none"
    }
  },

  dual_button_group_mobile_inner: {
    "@media only screen and (max-width: 639px)": {
      marginBottom: '24px',
      marginTop: '24px',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0px 16px 0px 16px'
    },
    "@media only screen and (min-width: 640px)": {
      display: "none"
    }
  },

  patient_mobile_single_button: {
    "@media only screen and (max-width: 639px)": {
      minWidth: "calc(100% - 40px)",
      marginTop: "24px",
      marginBottom: "24px",
    },
    "@media only screen and (min-width: 640px)": {
      display: "none"
    }
  },

  patient_continue_sticky: {
    "@media only screen and (max-width: 639px)": {
      position: "sticky",
      bottom: "0px",
      backgroundColor: "rgba(255,255,255,0.7)",
      backdropFilter: "blur(64px)",
      boxShadow:"0px -2px 4px 0px rgba(0,0,0,0.1)"

    },
    "@media only screen and (min-width: 640px)": {
      display: "none"
    }
  },

  patient_continue_sticky_inner: {
    "@media only screen and (max-width: 639px)": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (min-width: 640px)": {
      display: "none"
    }
  },

  important_info_box: {
    padding: `${dTokens.global_unit_small} ${dTokens.global_unit_small} 0 ${dTokens.global_unit_small}`,
    background: dTokens.res_mod_green_50,
    borderRadius: dTokens.dialog_radius,
  },

  patient_response_container: {
    paddingBottom: dTokens.global_unit_small,
  },

  patient_response_question: {
    display: "inline",
  },

  patient_response_answer: {
    paddingLeft: dTokens.global_unit_small,
    display: "inline",
  },

  magnet_warning_icon: {
    width: "20px",
    height: "20px"
  },

  magnet_warning_list: {
    marginTop: 0,
    marginBottom: 0,
    paddingLeft: "18px"
  },

  // The header and footer elements are contained within the main body,
  // which is centered with a max width, and so the header and footer are
  // also centered with a max width.  This style is to stretch the header
  // and footer beyond the bounds of their container and have them take up
  // the entire width of the page.
  headerFooterContainer: {
    width: "100dvw",
    left: "calc(-50lvw + 50%)",
    position: "relative"
  },

  browserNotSupportedContainer: {
    position: "absolute"
  },

  headerContent: {
    width: "600px",
    paddingTop: "17px",
    marginLeft: "auto",
    marginRight: "auto",
    "@media only screen and (max-width: 639px)": {
      paddingLeft: "20px",
      paddingRight: "20px",
      width: "100%"
    }
  },
  
  headerLeft: {
    display: "grid",
    justifyItems: "left",
    justifyContent: "left"
  },
  
  headerRight: {
    display: "grid",
    justifyItems: "right",
    justifyContent: "right"
  },

  headerCenter: {
    display: "grid",
    justifyItems: "center",
    justifyContent: "center"
  },

  footerContent: {
    padding: "16px 24px",
    display: "flex"
  },

  // Text styles from http://ux-resmed.ec2.local/?page_id=1508
  res_heading1: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_h1,
    fontSize: dTokens.font_size_h1,
  },
  res_heading2: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_h2,
    fontSize: dTokens.font_size_h2,
  },
  res_heading3: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_h3,
    fontSize: dTokens.font_size_h3,
  },
  res_heading4: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_h4,
    fontSize: dTokens.font_size_h4,
  },
  res_heading5: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_h5,
    fontSize: dTokens.font_size_h5,
  },
  res_heading6: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_h6,
    fontSize: dTokens.font_size_h6,
  },
  res_bodyCopy: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_body,
    fontSize: dTokens.font_size_body,
  },
  res_copyLink: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_body,
    fontSize: dTokens.font_size_body,
    color: resMedLightBlue,
    "&:hover": {
      textDecoration: "underline",
      backgroundColor: "transparent",
    },
  },
  res_standaloneLink: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_button,
    fontSize: dTokens.font_size_button,
    color: resMedLightBlue,
    "&:hover": {
      textDecoration: "underline",
      backgroundColor: "transparent",
    },
    padding: "6px 0",
    textDecoration: "none",
  },
  res_buttonLabel: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_button,
    fontSize: dTokens.font_size_button,
  },
  res_errorText: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_form_error,
    fontSize: dTokens.font_size_form_error,
    color: dTokens.color_text_error,
  },
  res_small_paragraph: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_small,
    fontSize: dTokens.font_size_small,
  },
  res_information_text: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_normal,
    fontSize: dTokens.font_size_small,
  },
  res_caption: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_caption,
    fontSize: dTokens.font_size_caption,
  },
  res_captionLink: {
    textTransform: "none",
    fontWeight: dTokens.font_weight_caption,
    fontSize: dTokens.font_size_caption,
    color: resMedLightBlue,
    "&:hover": {
      textDecoration: "underline",
      backgroundColor: "transparent",
    },
  },

  res_survey_header: {
    fontSize: providerDTokens.font_size_header_h2,
    fontWeight: providerDTokens.font_weight_normal,
    color: providerDTokens.font_colour_header_h2,
  },

  // Provider text styles
  res_provider_page_header: {
    fontSize: providerDTokens.font_size_page_header_h1,
    fontWeight: providerDTokens.font_weight_page_header_h1,
    color: providerDTokens.font_colour_page_header_h1,
  },
  res_provider_header: {
    fontSize: providerDTokens.font_size_header_h2,
    fontWeight: providerDTokens.font_weight_header_h2,
    color: providerDTokens.font_colour_header_h2,
  },
  res_provider_subheader: {
    fontSize: providerDTokens.font_size_subheader_h3,
    fontWeight: providerDTokens.font_weight_subheader_h3,
    color: providerDTokens.font_colour_subheader_h3,
  },
  res_provider_title: {
    fontSize: providerDTokens.font_size_title_h4,
    fontWeight: providerDTokens.font_weight_title_h4,
    color: providerDTokens.font_colour_title_h4,
  },
  res_provider_subtitle: {
    fontSize: providerDTokens.font_size_subtitle_h5,
    fontWeight: providerDTokens.font_weight_subtitle_h5,
    color: providerDTokens.font_colour_subtitle_h5,
  },
  res_provider_body_text: {
    fontSize: providerDTokens.font_size_body_text,
    fontWeight: providerDTokens.font_weight_body_text,
    color: providerDTokens.font_colour_body_text,
  },
  res_provider_text_link: {
    fontSize: providerDTokens.font_size_text_link,
    fontWeight: providerDTokens.font_weight_text_link,
    color: providerDTokens.font_colour_text_link,
    textDecoration: "none",
  },
  res_provider_data_values: {
    fontSize: providerDTokens.font_size_data_values,
    fontWeight: providerDTokens.font_weight_data_values,
    color: providerDTokens.font_colour_data_values,
  },
  res_provider_caption: {
    fontSize: providerDTokens.font_size_caption,
    fontWeight: providerDTokens.font_weight_caption,
    color: providerDTokens.font_colour_caption,
  },
  res_provider_graph_elements: {
    fontSize: providerDTokens.font_size_graph_elements,
    fontWeight: providerDTokens.font_weight_graph_elements,
    color: providerDTokens.font_colour_graph_elements,
  },
  res_provider_form_labels: {
    fontSize: providerDTokens.font_size_form_labels,
    fontWeight: providerDTokens.font_weight_form_labels,
    color: providerDTokens.font_colour_form_labels,
  },
  res_provider_table_headers_12: {
    fontSize: providerDTokens.font_size_table_headers_12,
    fontWeight: providerDTokens.font_weight_table_headers_12,
    color: providerDTokens.font_colour_table_headers_12,
  },
  res_provider_table_headers_14: {
    fontSize: providerDTokens.font_size_table_headers_14,
    fontWeight: providerDTokens.font_weight_table_headers_14,
    color: providerDTokens.font_colour_table_headers_14,
  },
  res_provider_table_content_12: {
    fontSize: providerDTokens.font_size_table_content_12,
    fontWeight: providerDTokens.font_weight_table_content_12,
    color: providerDTokens.font_colour_table_content_12,
  },
  res_provider_table_content_14: {
    fontSize: providerDTokens.font_size_table_content_14,
    fontWeight: providerDTokens.font_weight_table_content_14,
    color: providerDTokens.font_colour_table_content_14,
  },
  res_provider_small_button_label: {
    fontSize: providerDTokens.font_size_small_button_label,
    fontWeight: providerDTokens.font_weight_small_button_label,
    color: providerDTokens.font_colour_small_button_label,
  },

  bulletText: {
    fontSize: "17px",
    color: dTokens.res_grey_800,
  },

  retry_try_this_li: {
    paddingBottom: 10,
  },

  noOutline: {
    outline: "none"
  },

  contentOuterFlexBox: {
    display: "flex",
    flexFlow: "column nowrap",

    minHeight: contentHeight,
    maxHeight: contentHeight,
    overflow: "auto"
  },

  contentInnerOverFlowBox: {
    overflowY: "auto",
    overflowX: "hidden",
    flexShrink: 100,

    "@media only screen and (max-width: 639px)": {
      overflowY: "auto",
      marginBottom: "84px"
    }
  },

  navButtonsBox: {
    "@media only screen and (min-width: 640px)": {
      marginTop: 0
    }
  },

}));

export default MaskSelectorToolStyles;
